
import React, { useRef, useState } from "react";
import { Cropper } from "react-cropper";
import "cropperjs/dist/cropper.css";

const ImageCropper = () => {
  const cropperRef = useRef(null);
  const [image, setImage] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleCrop = () => {
    const cropper = cropperRef.current.cropper;
    setCroppedImage(cropper.getCroppedCanvas().toDataURL());
  };

  return (
    <div className="container mt-6">
        <div className="card">
          <div className="card-header">
              <h3 className="mb-0">React Image Cropper</h3>
          </div>
          <div className="card-block">
            <input type="file" accept="image/*" onChange={handleImageUpload} />
            {image && (
              <div style={{ marginTop: "20px" }}>
                <Cropper
                  src={image}
                  style={{ height: 300, width: "100%" }}
                  aspectRatio={16 / 9} // Change aspect ratio if needed
                  guides={true}
                  ref={cropperRef}
                  viewMode={1}
                  background={false}
                />
                <button onClick={handleCrop} style={{ marginTop: "10px" }}>
                  Crop Image
                </button>
              </div>
            )}
            {croppedImage && (
              <div style={{ marginTop: "20px" }}>
                <h3>Cropped Image:</h3>
                <img src={croppedImage} alt="Cropped" style={{ maxWidth: "100%" }} />
              </div>
            )}
          </div>
        </div>
    </div>
  );
};

export default ImageCropper;
